import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentService } from '../../../../../services/payment.service';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { AppConfig } from '../../../../../app.config';
import { HelpersService } from '../../../../../services/helpers.service';

@Component({
  selector: 'app-connect-stripe',
  templateUrl: './connect-stripe.component.html',
  styleUrls: ['./connect-stripe.component.scss'],
})
export class ConnectStripeComponent implements OnInit {
  @Input() partner;
  public connected: boolean = false;
  public busy: boolean = false;
  public win;
  public linkedToStripeConnect: boolean = false;
  public validPOSConnected: boolean = false;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public paymentService: PaymentService,
    public posIntegrationService: PosIntegrationService,
    public appConfig: AppConfig,
    public helpersService: HelpersService,
  ) {}

  ngOnInit() {
    this.checkIfLinkedToStripeConnect();
  }

  checkIfLinkedToStripeConnect() {
    this.busy = true;
    this.paymentService
      .checkPartnerLinkedStripeConnect(this.partner.ID)
      .subscribe(
        (result) => {
          if (result && result.linked) {
            this.linkedToStripeConnect = true;
            this.busy = false;

            this.posIntegrationService
              .checkPOSIntegration(this.partner.ID, this.partner.POSSystemID)
              .subscribe((res) => {
                if (
                  res &&
                  res.ConnectedPOS &&
                  (res.ConnectedPOS === 6 || res.ConnectedPOS === 3)
                ) {
                  this.validPOSConnected = true;
                } else {
                  this.validPOSConnected = false;
                }
              });
          } else {
            this.linkedToStripeConnect = false;
            this.busy = false;
          }
        },
        (error) => {
          this.busy = false;
        },
      );
  }

  connectStripe() {
    localStorage.setItem('StripePartnerID', this.partner.ID);
    this.paymentService.getStripeClientID().subscribe((result) => {
      var email = this.helpersService.getProfileData().Email;
      var client_id = result.stripeClientId;
      //var url = `https://connect.stripe.com/express/oauth/authorize?client_id=${client_id}&stripe_user[email]=${email}`;
      var url = `https://connect.stripe.com/oauth/v2/authorize?response_type=code&client_id=${client_id}&scope=read_write`;
      this.win = this.paymentService.launchStripeConnectPopup(url);
      this.busy = true;
      this.checkWindow();
    });
  }

  disconnectStripe() {
    this.busy = true;
    this.paymentService
      .disconnectPartnerFromStripeConnect(this.partner.ID)
      .subscribe(
        (result) => {
          this.busy = false;
          this.checkIfLinkedToStripeConnect();
        },
        (error) => {
          this.busy = false;
        },
      );
  }

  checkWindow() {
    setTimeout(() => {
      if (this.win === null || this.win.parent === null) {
        this.busy = false;
        this.checkIfLinkedToStripeConnect();
      } else {
        this.checkWindow();
      }
    }, 2000);
  }
}
